import { createSlice } from "@reduxjs/toolkit";

const POPUP_STATE = {
  notesPopup:{
    showNotes:false,
    notes:""
  }
};


const popupSlice = createSlice({
  name: "popup",
  initialState: POPUP_STATE,
  reducers: {
    setNotes: (state, action) => {
      state.notesPopup = action.payload;
    },
  }
});

export const { setNotes } = popupSlice.actions;

export default popupSlice.reducer;